import metadata from "$public/metadata.json";
import { capitalize } from "$utils/capitalize";
export const chatFeedIntegrationTypeChoices = metadata.ChatFeedIntegration.integrationType.type
    .sort()
    .map((id) => ({ id, name: capitalize(id).replaceAll("_", " ") }));
